import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";

class AccountDropdown extends Class{

	constructor(element){
		super();
		this.element = $(element);
		this.header = this.element.find('h2').first();
		this.dropdown = this.element.find('ul').first();
		this.selected = this.dropdown.find('li.selected span').first();
		this.headerText = this.header.html();
		this.selectedText = this.selected.html();
		this.setUpEvents();
		this.toggleHeaderText();
	}

	setUpEvents(){
		var self = this;
		this.header.on('click', function(){
			self.toggleMenu();
		});
	}

	toggleMenu(){
		if(this.dropdown.hasClass('open')){
			this.dropdown.removeClass('open');
		} else {
			this.dropdown.addClass('open');
		}
		this.toggleHeaderText();
	}

	toggleHeaderText(){
		if(this.header.html() === this.headerText){
			this.header.html(this.selectedText);
		} else {
			this.header.html(this.headerText);
		}
	}

}

export { AccountDropdown };


// WEBPACK FOOTER //
// ./Javascript/core/classes/account/account.menu.class.js